import { ERoleAccess } from "@/frontend/app/providers/router/config/routeConfig";
import { EContent } from "@/frontend/components/DashboardHeader/types/types";
import { EntryPointsIcon } from "@/frontend/shared/assets/icons";
import { Company2Icon } from "@/frontend/shared/assets/icons/Company2Icon";
import { CompassIcon } from "@/frontend/shared/assets/icons/CompassIcon";
import { TrendUp2Icon } from "@/frontend/shared/assets/icons/TrendUp2Icon";
import { ELOCAL_STORAGE_KEY } from "@/frontend/shared/const/const";
import {
  getRouteCompanies,
  getRouteCompanyProfile,
  getRouteDashboard,
  getRouteExpertCompaniesById,
  getRouteExpertOrganizationById,
  getRouteFounderCompanyProfile,
  getRoutePortfolioCompanyProfile
} from "@/frontend/shared/const/router";
import { useHistoricalNavigate } from "@/frontend/shared/lib/useHistoricalNavigate/useHistoricalNavigate";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

type TTab = {
  icon: JSX.Element;
  label: string;
  goTo: () => void;
  isActive: boolean;
  id: string;
};

export function getTabsForUser(
  userType?: ERoleAccess,
  expertOrgId?: number,
  setActiveContent?: (value: EContent) => void,
  activeContent?: EContent
): TTab[] | null {
  const { navigate, getPrevRoute } = useHistoricalNavigate();
  const prevUrl = getPrevRoute();
  const { pathname } = useLocation();
  const prevRouteDirectory = prevUrl?.split("/")[1];

  const founderCompanyProfileDirectory = getRouteFounderCompanyProfile().replace(/\//g, "");
  const companyProfileDirectory = getRouteCompanyProfile("").replace(/\//g, "");
  const portfolioProfileDirectory = getRoutePortfolioCompanyProfile("").replace(/\//g, "");
  const contentView = localStorage.getItem(ELOCAL_STORAGE_KEY.CONTENT)?.replace(/"/g, "");

  const currentDirectory = pathname.split("/")[1];
  const isPortfolioCompanyProfile = portfolioProfileDirectory === currentDirectory;
  const isCompanyProfile = companyProfileDirectory === currentDirectory;

  const prevRoute = useMemo(() => {
    switch (true) {
      case isPortfolioCompanyProfile && prevRouteDirectory === companyProfileDirectory:
        return EContent.DISCOVER;
      case isPortfolioCompanyProfile && contentView === EContent.PORTFOLIO:
        return EContent.PORTFOLIO;
      case isPortfolioCompanyProfile && contentView === EContent.PIPELINE:
        return EContent.PIPELINE;
      case isCompanyProfile:
        return EContent.DISCOVER;
      default:
        return EContent.DASHBOARD;
    }
  }, []);

  const goToCompanies = () => navigate(getRouteCompanies());

  if (userType === ERoleAccess.FOUNDER) {
    return [
      {
        icon: <Company2Icon />,
        label: EContent.PROFILE,
        goTo: () => navigate(getRouteFounderCompanyProfile()),
        isActive: currentDirectory === founderCompanyProfileDirectory,
        id: "innoveraHeader-founder-profileButton"
      },
      {
        icon: <CompassIcon />,
        label: EContent.DISCOVER,
        goTo: goToCompanies,
        isActive: prevRoute === EContent.DISCOVER || activeContent === EContent.DISCOVER,
        id: "innoveraHeader-founder-discoverButton"
      }
    ];
  } else if (userType === ERoleAccess.INVESTOR) {
    return [
      {
        icon: <EntryPointsIcon />,
        label: EContent.PIPELINE,
        goTo: () => {
          setActiveContent?.(EContent.PIPELINE);
          localStorage.setItem(ELOCAL_STORAGE_KEY.CONTENT, JSON.stringify(EContent.PIPELINE));
          navigate(getRouteDashboard());
        },
        isActive: prevRoute === EContent.PIPELINE || activeContent === EContent.PIPELINE,
        id: "innoveraHeader-investor-pipelineButton"
      },
      // {
      //   icon: <Company2Icon />,
      //   label: EContent.PORTFOLIO,
      //   goTo: () => {
      //     setActiveContent?.(EContent.PORTFOLIO);
      //     localStorage.setItem(ELOCAL_STORAGE_KEY.CONTENT, JSON.stringify(EContent.PORTFOLIO));
      //     navigate(getRouteDashboard());
      //   },
      //   isActive: prevRoute === EContent.PORTFOLIO || activeContent === EContent.PORTFOLIO
      // },
      {
        icon: <CompassIcon />,
        label: EContent.DISCOVER,
        goTo: goToCompanies,
        isActive: prevRoute === EContent.DISCOVER || activeContent === EContent.DISCOVER,
        id: "innoveraHeader-investor-discoverButton"
      }
    ];
  } else if (userType === ERoleAccess.EXPERT && !!expertOrgId) {
    return [
      {
        icon: <TrendUp2Icon />,
        label: EContent.DASHBOARD,
        goTo: () => {
          setActiveContent?.(EContent.DASHBOARD);
          navigate(getRouteExpertOrganizationById(expertOrgId));
        },
        isActive: activeContent === EContent.DASHBOARD,
        id: "innoveraHeader-expert-dashboardButton"
      },

      {
        icon: <CompassIcon />,
        label: EContent.DISCOVER,
        goTo: () => navigate(getRouteExpertCompaniesById(expertOrgId)),
        isActive: prevRoute === EContent.DISCOVER || activeContent === EContent.DISCOVER,
        id: "innoveraHeader-expert-discoverButton"
      }
    ];
  }
  return null;
}
